import React, { FC, ReactNode, isValidElement, ChangeEvent, useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import Text, { TextProps } from '../Text';
import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';

export type Size = 'sm' | 'md';
export type LabelType = string | ReactNode;

interface ProgressLabelProps {
  height?: string;
  progress?: string;
  bgcolor?: string;
  ratingLabel?: '';
  prgPercentText?: string;
  textFontSize?: string;
  isHighest?: boolean;
  isFleek?: boolean;
  hideInternalContent?: boolean;
  indexNum?: number;
}

const ProgressLabel: FC<ProgressLabelProps> = (props: ProgressLabelProps) => {
  const {
    bgcolor,
    progress,
    height,
    ratingLabel,
    prgPercentText,
    textFontSize,
    isHighest,
    isDesktop,
    customerWords,
    isFleek = false,
    hideInternalContent,
    indexNum
  } = props;
  const Parentdiv = {
    height,
    width: isDesktop ? '180px' : '140px',
    backgroundColor: '#ebebeb',
    borderRadius: '4px',
    display: 'inline-block'
  };
  const progressPer = progress?.replace('%', '').trim();
  const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
  const starUrl = `${imageBaseUrl}/static/img/grey_small_star.svg`;

  const Childdiv = {
    height,
    width: `${progressPer}%`,
    backgroundColor: bgcolor,
    borderRadius: '4px',
    textAlign: 'right'
  };
  const cx = classNames.bind(styles);

  return (
    <>
      {ratingLabel && (
        <span
          aria-label={`${ratingLabel} star ratings`}
          aria-hidden={hideInternalContent}
          id={hideInternalContent ? `ratings${indexNum}` : undefined}
        >
          <span aria-hidden="true" tabIndex={-1} className={cx(
            'rate-cnt',
            isDesktop ? 'desk-rate-cnt' : 'mob-rate-cnt',
            isFleek ? 'fleek-mob-rate-cnt' : ''
          )}>
            {ratingLabel}
            <img
              className={cx('imageIcon', isDesktop ? 'desk-prog-icon' : 'mob-prog-icon')}
              src={starUrl}
              alt='Star icon'
              aria-hidden="true"
            />
          </span>
        </span>
      )}
      <div
        className={cx(
          isDesktop ? 'desk-progress' : 'mob-progress',
          isFleek ? 'fleek-mob-progress' : ''
        )}
        style={Parentdiv}
        aria-hidden={hideInternalContent}
        id={`mob-progress-${indexNum}`}
      >
        <div style={Childdiv}>
          <span />
        </div>
      </div>
      {prgPercentText ? (
        <span
          className={cx(
            isFleek ? 'fleek-prg-percent' : '',
            'prg-percent',
            isHighest ? cx('bold-text') : '',
            isDesktop ? 'desk-prog-per-txt' : 'mob-prog-per-txt'
          )}
          style={{ fontSize: textFontSize, color: isHighest ? '#202020' : '' }}
          aria-hidden={hideInternalContent}
          id={hideInternalContent ? `ratingspercentage${indexNum}` : undefined}
        >
          {`${prgPercentText}(${progressPer}%)`}
        </span>
      ) : (
        <span
          className={cx(
            'prg-percent',
            isHighest ? cx('bold-text') : '',
            isDesktop ? 'desk-prog-per-txt' : 'mob-prog-per-txt'
          )}
          style={{ fontSize: textFontSize, color: isHighest ? '#202020' : '' }}
          aria-hidden={hideInternalContent}
          id={hideInternalContent ? `ratingspercentage${indexNum}` : undefined}
        >{`${progressPer}%`}</span>
      )}
    </>
  );
};

ProgressLabel.defaultProps = {
  height: '',
  progress: '',
  bgcolor: '',
  ratingLabel: '',
  prgPercentText: '',
  textFontSize: ''
};

export default ProgressLabel;
